import { StyledFlex } from '@dreryk/react-components';

import { PatientGroups } from '~libs.desktop.shared.patient-groups';

import { AppointmentContextDialogTitleLoader } from './AppointmentContextDialogTitle.loader';
import { PatientHeading } from './PatientHeading';
import { VisitDate } from './VisitDate';

type AppointmentContextDialogTitleProps = Readonly<{ appointmentId: number }>;

export const AppointmentContextDialogTitle = (props: AppointmentContextDialogTitleProps): JSX.Element => {
   return (
      <AppointmentContextDialogTitleLoader appointmentId={props.appointmentId}>
         {({ appointmentDetails }) => (
            <StyledFlex gap={6} direction={'column'}>
               <div>
                  <PatientHeading patient={appointmentDetails.patient} />
                  <VisitDate beginDate={appointmentDetails.beginDate} endDate={appointmentDetails.endDate} />
               </div>

               {appointmentDetails.patient.patientGroups.length ? (
                  <PatientGroups patientGroups={appointmentDetails.patient.patientGroups} />
               ) : null}
            </StyledFlex>
         )}
      </AppointmentContextDialogTitleLoader>
   );
};
